module.exports = __webpack_public_path__ + "img/markerTramOrange.8ca6a2be.svg";